import {
  CALL_API,
} from './middleware';

export default ({
  endpoint,
  authenticated,
  microservice,
  types,
  method,
  data,
  contentType,
}) => {
  return {
    [CALL_API]: {
      endpoint,
      authenticated,
      microservice,
      types,
      method,
      data,
      contentType,
    },
  };
};
